// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vVa-","newExpiryDate":"styles_newExpiryDate__3Aqm2","footer":"styles_footer__1gRYJ"};